import { useEffect } from 'react'
import dashedLine from '../images/dashed-curved-filter-line.svg'
import { select } from 'd3'

type Screen2Props = {
  anchorRef: React.RefObject<HTMLDivElement>
}

const Screen2 = ({ anchorRef }: Screen2Props) => {
  const { x, y, width } = anchorRef.current?.getBoundingClientRect()!
  useEffect(() => {
    const ref = anchorRef.current
    select(ref).style('z-index', 1000)
    return () => {
      select(ref).style('z-index', 'initial')
    }
  }, [anchorRef])
  return (
    <div className="flex h-full bg-[#222222] opacity-[.78] w-screen relative">
      <div
        className="flex flex-col items-center w-[310px] gap-1 opacity-1 absolute"
        style={{
          left: `${width + x + 25}px`,
          top: `${y + window.scrollY}px`,
        }}
      >
        <p className="text-orange font-decimal text-[20px]">
          Apply filter from here, click on the i button to view dimensions
          definitions
        </p>
        <img src={dashedLine} alt="dashed line" className="self-start" />
      </div>
    </div>
  )
}
export default Screen2
